/**
 * QuotaDisplay Component - Shows AskSara quota usage
 */

import React from 'react';
import { useTier } from '../contexts/TierContext';

const QuotaDisplay = () => {
  const { tierInfo, isPremium } = useTier();

  if (!tierInfo) return null;

  if (isPremium) {
    return (
      <div className="bg-gradient-to-r from-purple-500 to-blue-500 rounded-lg shadow-md p-4 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold">Premium Tier</h3>
            <p className="text-sm">Unlimited AskSara questions</p>
          </div>
          <div className="text-3xl">∞</div>
        </div>
      </div>
    );
  }

  const { asksara_monthly_limit, asksara_questions_used_this_month, asksara_remaining } = tierInfo;
  const percentage = (asksara_questions_used_this_month / asksara_monthly_limit) * 100;
  
  // Color based on usage
  let bgColor = 'bg-green-500';
  let textColor = 'text-green-700';
  if (percentage >= 80) {
    bgColor = 'bg-red-500';
    textColor = 'text-red-700';
  } else if (percentage >= 60) {
    bgColor = 'bg-yellow-500';
    textColor = 'text-yellow-700';
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-lg font-semibold text-gray-900">AskSara Questions</h3>
        <span className={`text-sm font-medium ${textColor}`}>
          {asksara_remaining} remaining
        </span>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm text-gray-600">
          <span>Used {asksara_questions_used_this_month} of {asksara_monthly_limit}</span>
          <span>{percentage.toFixed(0)}%</span>
        </div>
        
        <div className="w-full bg-gray-200 rounded-full h-2.5">
          <div
            className={`${bgColor} h-2.5 rounded-full transition-all duration-300`}
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
        
        {asksara_remaining === 0 && (
          <div className="mt-2 p-2 bg-red-50 rounded-md">
            <p className="text-sm text-red-800">
              Monthly quota exceeded. 
              <a href="/#/upgrade" className="font-medium underline ml-1">
                Upgrade to Premium
              </a>
            </p>
          </div>
        )}
        
        {asksara_remaining > 0 && percentage >= 80 && (
          <div className="mt-2 p-2 bg-yellow-50 rounded-md">
            <p className="text-sm text-yellow-800">
              You're running low on questions. Consider upgrading for unlimited access.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuotaDisplay;
